module.exports = __webpack_public_path__ + "img/site-tesistan.71b25fd1.jpg";